import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-back', 'ArrowBack', [["path",{"d":"M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1","key":"svg-0"}]]);